import { useState } from 'react';
import { Button, Dialog } from '@/design-system';
import { resolveError } from '@/core/errors/resolveError';
import { managerConnectorService } from './api/connector-gateways.service';

export function RepairPairingDialog({ gatewayId, onClose }: { gatewayId: string; onClose: () => void }) {
  const [pairing, setPairing] = useState<{ code: string; expiresAt: string } | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  async function generate() {
    setBusy(true); setError('');
    try { setPairing(await managerConnectorService.createRepairPairingCode(gatewayId)); }
    catch (err) { setError(resolveError(err).message); }
    finally { setBusy(false); }
  }
  return <Dialog isOpen onClose={() => !busy && onClose()} title="Refazer pareamento">
    <div className="space-y-4">
      <p className="text-sm text-gray-600">Use após desconectar ou reinstalar o aplicativo. Clientes, vínculos, orçamentos e histórico serão preservados. Ao utilizar o código, a credencial anterior será invalidada.</p>
      {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
      {pairing && <div className="space-y-3 rounded border border-violet-200 bg-violet-50 p-4">
        <p className="text-sm font-medium">Código de pareamento</p>
        <code className="block select-all font-mono text-2xl tracking-wider">{pairing.code}</code>
        <p className="text-sm">Cole no aplicativo Orya Connector atualizado. Válido por 10 minutos e para um único uso.</p>
        <p className="text-xs text-gray-500">Válido até {new Date(pairing.expiresAt).toLocaleString('pt-BR')}</p>
        <Button variant="outline" onClick={async () => {
          try { await navigator.clipboard.writeText(pairing.code); setCopied(true); }
          catch { setError('Não foi possível copiar. Selecione o código e copie manualmente.'); }
        }}>{copied ? 'Código copiado' : 'Copiar código'}</Button>
      </div>}
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={onClose} disabled={busy}>{pairing ? 'Fechar' : 'Cancelar'}</Button>
        {!pairing && <Button onClick={() => void generate()} disabled={busy}>{busy ? 'Gerando…' : 'Gerar código'}</Button>}
      </div>
    </div>
  </Dialog>;
}
